import { Component, Input, OnChanges } from '@angular/core';
import { PetDto } from '../../services/service-proxy/service-proxies';
import { PetClinicalService, Recordatorio } from '../../services/pet-clinical.service';

@Component({
  selector: 'app-mis-mascotas-resumen',
  templateUrl: './mis-mascotas-resumen.component.html',
  styleUrls: ['./mis-mascotas-resumen.component.scss']
})
export class MisMascotasResumenComponent implements OnChanges {

  @Input() pets? : PetDto[] | null;

  /** Proxima vacuna real por mascota (petId -> recordatorio o null). */
  vacunas = new Map<number, Recordatorio | null>();

  constructor(private clinico : PetClinicalService) {}

  ngOnChanges() {
    this.cargarVacunas();
  }

  /** Como mucho tres tarjetas en el resumen; el resto va en "Ver todas". */
  get visibles() : PetDto[] {
    return (this.pets ?? []).filter(p => !p.deceased).slice(0, 3);
  }

  get hayMascotas() : boolean {
    return this.visibles.length > 0;
  }

  /**
   * Una llamada por mascota visible (a lo sumo tres) para el proximo control.
   * Reminder/GetAll es liviano; se piden en paralelo y cada tarjeta se actualiza
   * cuando llega la suya.
   */
  private cargarVacunas() {
    for (const pet of this.visibles) {
      if (this.vacunas.has(pet.id)) continue;
      this.clinico.proximaVacuna(pet.id).subscribe(r => this.vacunas.set(pet.id, r));
    }
  }

  vacunaDe(pet : PetDto) : Recordatorio | null {
    return this.vacunas.get(pet.id) ?? null;
  }

  /** Texto del boton segun haya o no un control cargado para la mascota. */
  textoAccion(pet : PetDto) : string {
    return this.vacunaDe(pet) ? 'Ver su historia clínica' : 'Ver su ficha';
  }
}
